var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hevgn75l1a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1 29.9a9.426 9.426 0 0 1-3.171-.586 5.305 5.305 0 0 1-1.964-1.278 5.265 5.265 0 0 1-1.279-1.963 9.428 9.428 0 0 1-.586-3.171c-.083-1.8-.1-2.34-.1-6.902s.018-5.1.1-6.901a9.48 9.48 0 0 1 .586-3.17 5.326 5.326 0 0 1 1.278-1.965 5.273 5.273 0 0 1 1.964-1.278A9.427 9.427 0 0 1 9.099 2.1C10.9 2.017 11.441 2 16 2c4.56 0 5.1.018 6.901.1a9.48 9.48 0 0 1 3.171.586c.742.274 1.413.71 1.964 1.278a5.289 5.289 0 0 1 1.278 1.964 9.426 9.426 0 0 1 .587 3.171c.082 1.802.1 2.341.1 6.901s-.018 5.1-.1 6.902a9.471 9.471 0 0 1-.587 3.17 5.655 5.655 0 0 1-3.242 3.242 9.426 9.426 0 0 1-3.171.587c-1.8.082-2.341.1-6.902.1-4.56 0-5.1-.017-6.9-.1",
    fill: "#596AE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.352 11.01h1.6V8.556c-.252 0-.514-.058-.776-.077h-1.445a3.54 3.54 0 0 0-2.037.63 3.055 3.055 0 0 0-1.231 2.037 7.179 7.179 0 0 0-.087 1.047v1.853h-2.338v2.725h2.328v6.857h2.841v-6.867h2.318l.36-2.744h-2.697v-1.94c.049-.805.524-1.048 1.164-1.067z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hevgn75l1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookColor);
export default __webpack_public_path__ + "static/media/FacebookColor.acb623be56c814dd5ca5357efe6c8e28.svg";
export { ForwardRef as ReactComponent };